import Alerts from 'lib/alerts.js';
import EmployerBaseRouter from './Base.js';
import EmployeeTotalsView from '../views/reports/EmployeeTotals.js';
import EmployeeLeaveView from '../views/reports/EmployeeLeave.js';
import VarianceReportView from '../views/reports/Variance.js';
import Employees from 'newCollections/employees.js';
import LeaveRequests from 'newCollections/leave-requests.js';
import LeaveTypes from 'newCollections/leave-types.js';
import CompanyLocations from 'newCollections/company-locations.js';
import Payrolls from 'newCollections/payrolls.js';
import Report from 'newModels/report.js';
import queryString from 'query-string';
import moment from 'moment';
import Log from 'lib/log';
import loader from 'helpers/loader';
import Promise from 'bluebird';

const log = Log('employer/report-router');
let view = null; // backbone view
module.exports = EmployerBaseRouter.extend({
    routes: {
        'reports/leave': 'leave',
        'reports/leave?*filtersQueryString': 'leave',
        'reports/totals': 'totals',
        'reports/totals?*filtersQueryString': 'totals',
        'reports/variance': 'variance'
    },

    titles: {
        'reports/leave': 'Leave report',
        'reports/totals': 'Totals report',
        'reports/variance': 'Variance report'
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {log: log});
        EmployerBaseRouter.prototype.initialize.apply(this, [this.options]);
    },

    leave: function(filtersQueryString) {
        const stopLoader = loader.startFullPage(this.el);
        const company = app.company;

        const filters = _.defaults(
            queryString.parse(filtersQueryString) || {}, {
                'period':         'current',
                'leaveType':      '',
                'employee[]':     [],
            });

        if (typeof filters['employee[]'] !== 'object') {
            filters['employee[]'] = [filters['employee[]']];
        }

        const employeeIds = filters['employee[]'];
        const balanceMap = {};

        const employees = new Employees(null, {
            company,
            pagination: false
        });

        const employeeFetchOptions = {
            filter: {
                limit: 9999,
                where: {cessationDate: null}
            }
        };
        return employees.fetch(employeeFetchOptions)
            .then(() => {
                employees.forEach(emp => emp.company = company);

                const leaveTypeIds = app.leaveTypes.map(t => t.id);
                const requestLeaveType = employeeRequests =>
                    employeeRequests.map(
                        req => req.get('typeId')
                    );

                const requestLeaveTypeByEmployee = (
                    typeId,
                    employeeId,
                    employeeRequests
                ) => employeeRequests.filter(req =>
                        req.get('employeeId') === employeeId &&
                        req.get('typeId') === typeId
                    ).length;

                const enabledType = app.leaveTypes.filter(
                    type => !type.get('hiddenAt')
                ).map(type => type.id);

                const defaultLeaveTypes = app.leaveTypes.filter(
                    type => !type.get('companyId')
                ).map(type => type.id);

                return LeaveRequests
                    .fetchForTypes({
                        typeIds: leaveTypeIds,
                        employeeIds: employees.map(e => e.id)
                    })
                    .then(employeeRequests => {
                        const leaveTypes = new LeaveTypes(
                            app.leaveTypes.filter(type =>
                                requestLeaveType(employeeRequests)
                                    .includes(type.id) ||
                                enabledType.includes(type.id) ||
                                defaultLeaveTypes.includes(type.id)
                            )
                        );
                        return Promise.all([employeeRequests, leaveTypes]);
                    }).then(([employeeRequests, leaveTypes]) => {
                        if (!filters.leaveType) {
                            filters.leaveType = leaveTypeIds[0];
                        } // set initial leaveType
                        if (view) {
                            //el: this.el in constructor is denying view
                            // reference to be collected after change route
                            // so, keep it in a broader variable and clean it up manually
                            view.remove();
                        }
                        view = new EmployeeLeaveView({
                            el: this.el,
                            filters,
                            employees,
                            leaveTypes: leaveTypes // filter's leave type
                        });

                        const currentLeaveType = leaveTypes.find(
                            type => type.id === filters.leaveType
                        );

                        const filteredEmployees = (
                            employeeIds.length ?
                                new Employees(
                                    employees.filter(e =>
                                        employeeIds.includes(e.id)
                                    )
                                ) :
                                employees.clone()
                        ).filter(
                            employee => !currentLeaveType.get('gender') ||
                                currentLeaveType.get('gender') ===
                                    employee.get('gender')
                        );

                        return Promise.each(filteredEmployees, employee => {
                            const {start} = employee
                                .getApplicableLeavePeriodDates(moment());
                            let periodStartDate = start.toDate();
                            let periodEndDate = moment().toDate();
                            let includeFutureLeaveTaken = false;
                            switch (filters.period) {
                                case 'previous':
                                    const prevPeriod = employee
                                        .getApplicableLeavePeriodDates(
                                            moment().subtract(1, 'year')
                                                .endOf('day')
                                        );
                                    periodStartDate = prevPeriod
                                        .start.toDate();
                                    periodEndDate = prevPeriod
                                        .end.toDate();
                                    includeFutureLeaveTaken = true;
                                    break;
                                case 'custom':
                                    periodEndDate = filters.date ?
                                      moment(filters.date, 'YYYY/MM/DD')
                                          .endOf('day')
                                          .toDate() :
                                      moment().toDate();
                                    includeFutureLeaveTaken = false;
                                    periodStartDate = employee
                                        .getApplicableLeavePeriodDates(
                                            periodEndDate
                                        ).start.toDate();
                                    break;
                                case 'current':
                                    includeFutureLeaveTaken = true;
                                    break;
                                default:
                                    break;
                            }
                            return leaveTypes.fetchBalancesMap(
                                employee, periodEndDate,
                                        !includeFutureLeaveTaken
                            )
                            .then((balance) => {
                                balanceMap[employee.id] = balance;
                                balanceMap[employee.id].employee = employee;
                                balanceMap[employee.id].types = leaveTypes
                                    .filter(type =>
                                        (
                                            !type.get('gender') ||
                                                type.get('gender') ===
                                                    employee.get('gender')
                                        ) && (
                                            requestLeaveTypeByEmployee(
                                            type.id,
                                            employee.id,
                                            employeeRequests
                                        ) ||
                                        enabledType.includes(type.id) ||
                                        defaultLeaveTypes.includes(type.id)
                                        )
                                    );
                            });
                        })
                        .then(() => {
                            view.render(balanceMap);
                        });
                    });
            })
            .finally(stopLoader);
    },

    totals: function(filtersQueryString) {

        const stopLoader = loader.startFullPage(this.el);
        const filters = Object.assign({
            'dateRange': 'current_year',
            'from': moment().startOf('year').toDate(),
            'to': moment().startOf('day').toDate(),
            'group[]': ''
        }, queryString.parse(filtersQueryString) || {});

        const employees = new Employees(null, {
            company: app.company,
            pagination: false
        });

        const locations = new CompanyLocations(null, {
            company: app.company,
            pagination: false
        });

        const payrolls = new Payrolls(null, {
            company: app.company,
            pagination: false,
            sortKey: 'periodDate',
            sortOrder: 'descending'
        });

        filters.from = filters.from !== '' ?
            moment(filters.from).hour(12).toDate() : '',
        filters.to = filters.to !== '' ?
            moment(filters.to).hour(12).toDate() : '';

        if (typeof filters['group[]'] !== 'object') {
            filters['group[]'] = [filters['group[]']];
        }

        let employeesFilter = filters['group[]'];
        let locationsFilter = filters['group[]'];
        if (filters.groupBy === 'location') {
            employeesFilter = null;
        } else {
            locationsFilter = null;
        }

        Promise.join(
            locations.fetch({filter: {limit: 9999}}),
            employees.fetch({
                filter: {
                    where: {
                        hasPayslips: true
                    },
                    limit: 9999
                }
            }),
            Report.totals({
                companyId: app.company.id,
                employees: employeesFilter,
                locations: locationsFilter,
                fromDate: filters.from,
                toDate: filters.to
            }),
            payrolls.fetch({
                filter: {
                    where: {status: 9},
                    limit: 9999
                }
            })
        ).then(([a, b, totals, payrolls]) => {
            const fromPeriod = payrolls.length ?
                moment(payrolls.last().get('periodDate')) :
                moment();
            const toPeriod = payrolls.length ?
                moment(payrolls.first().get('periodDate')) :
                moment();
            this.view = new EmployeeTotalsView({
                el: this.el,
                employees,
                locations,
                filters,
                totals: totals.totals,
                grandTotal: totals.grandTotals,
                fromPeriod,
                toPeriod
            });
        }).catch(error => {
            log.error(error);
            Alerts.show('error', {
                text: `Failed fetching the data. ` +
                    `Might've been due to the oversized data. ` +
                    `Please try filtering your data by shorter period/ less ` +
                    `employees.`,
                callback: () => app.mainRouter.navigate('reports/totals')
            });
        }).finally(stopLoader);
    },

    variance: function() {
        const stopLoader = loader.startFullPage(this.el);
        const payrolls = new Payrolls(null, {
            company: app.company,
            pagination: false,
            sortKey: 'periodDate',
            sortOrder: 'descending'
        });

        return payrolls.fetch({
            filter: {
                where: {status: 9},
                limit: 2
            }
        }).then(() => {
            this.view = new VarianceReportView({
                el: this.el,
                collection: payrolls
            }).render();
        }).finally(stopLoader);
    }
});



// WEBPACK FOOTER //
// ./app/employer/routers/Report.js